import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { useTranslation } from 'react-i18next';
import { LoadingState } from './design-system/States';

const PrivateRoute = ({ children, adminOnly = false }) => {
  const { currentUser, loading } = useAuth();
  const location = useLocation();
  const { t } = useTranslation('common');

  // Mostrar spinner mientras se carga
  if (loading) {
    return (
      <div className="container mt-5">
        <LoadingState label={t('ui.loading')} />
      </div>
    );
  }

  // Verificar autenticación
  if (!currentUser) {
    // Guardar la ubicación actual para redirigir después del login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Verificar permisos de admin si es necesario
  if (adminOnly && !currentUser.is_staff && !currentUser.is_superuser) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default PrivateRoute;
